import React from 'react';

const RPAReports = () => {
	return <></>;
};

export default RPAReports;
